<template>
  <div id="app">
    <router-view/>

    <Modal v-model="showRulesModal" title="How to play">
    The goal is to make chains of five card tiles in a row of your color. Your color is shown as the background color of your hand. If you are playing with two teams, you must complete two chains in order to win the game. If you are playing with three teams, the first team to complete a single chain wins.<br><br>

    To claim a tile, play a card in your hand by tapping the board location matching a card in your hand. Once you play, you should immediately draw another card by tapping the draw pile. If you fail to draw before your opponent plays, you will be down a card for the rest of the game. Corner tiles are wild and may be used by any team, requiring only four claimed tiles to complete a chain.<br><br>

    Two-eyed jacks are wild and you may play them on any tile that is not already claimed by first tapping your jack and then tapping the board location you wish to claim. One-eyed jacks may be used to remove another team's tile. Tap your jack and then tap a claimed tile to remove the opponent's color.<br><br>

    <span style="font-size: 20px;">Rules</span><br><br>

    You can play with two or three teams and between two and twelve players total. Play alternates among teams until the game is over.<br><br>

    You may not communicate with other players on your team regarding strategy or cards in your hand.<br><br>

    If you fail to draw a card before the next player completes their turn, you must play the rest of the game with one fewer card in your hand.<br><br>

    Your second chain may contain up to one tile from your previously completed chain.<br><br>

    If you have a card in your hand that cannot be played on an open board tile, you may trade it in at the start of your turn by clicking on the card in your hand and then clicking the discard pile. You may do this only once per turn.<br><br>

    You may not use a one-eyed jack to remove the opponent's color for a tile that is part of a completed chain.<br><br>

    If you run out of cards in the deck, play continues until all players are out of cards. At that point, if one team has more chains than all other teams, that team is the winner. Otherwise, the game ends in a tie.<br><br>

    <span style="font-size: 20px;">Built with</span><br><br>

    <a href="https://totalnonsense.com/open-source-vector-playing-cards/">Vectorized Playing Cards 3.1</a><br>
    Copyright 2011, 2019 by Chris Aguilar<br>
    Licensed under: <a href="https://www.gnu.org/licenses/lgpl-3.0.html">LGPL 3.0</a>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { EventBus } from '@/events.js'

export default {
	name: 'App',
	data: function () { return {
		showRulesModal: false
	} },
  components: { Modal },
	methods: {
		showHowToPlayModal () { this.showRulesModal = true; }
	},
	created () {
		EventBus.$on('howto', this.showHowToPlayModal);
	}
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
